function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoInputTemplate = require('./saito-input.template');
var SaitoInputLargeTemplate = require('./saito-input-large.template');
var SaitoInputSelectionBox = require('./saito-input-selection-box.template');
var SaitoLoader = require('./../saito-loader/saito-loader');
var SaitoInput = /*#__PURE__*/function () {
  function SaitoInput(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var photo_handle = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, SaitoInput);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.loader = new SaitoLoader(app, mod, '.photo-window');
    this.callbackOnReturn = null;
    this.callbackOnUpload = null;
    this.display = 'small'; //chat-container, medium=chat-static, large=redsquare_post
    this.placeholder = 'say something';
    this.open_tab = '';
    this.mentions = [];
    this.quote = '';
    this.quote_src = '';
    this.photo_handle = 'hidden_file_element_' + photo_handle;
    this.enable_mentions = true;
  }
  return _createClass(SaitoInput, [{
    key: "render",
    value: function render() {
      var autofocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.display == 'large') {
        if (!document.querySelector(this.container + ' .saito-input')) {
          this.app.browser.prependElementToSelector(SaitoInputLargeTemplate(this, this.placeholder), this.container);
        }
        this.attachLargeEvents();
      } else {
        if (!document.querySelector(this.container + ' .saito-input')) {
          this.app.browser.prependElementToSelector(SaitoInputTemplate(this.placeholder), this.container);
        }
        this.attachEvents();
      }
      if (autofocus) {
        this.focus();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var input_icon = document.querySelector("".concat(this.container, " .saito-input .saito-emoji"));
      if (input_icon) {
        input_icon.onclick = function (e) {
          e.stopPropagation();
          if (document.querySelector('.saito-input-selection-box')) {
            _this.removeSelectionBox();
          } else {
            if (!document.querySelector('.saito-input-selection-box')) {
              var _footer$closest;
              // Prefer inserting as a `.chat-popup` grid row above the footer so the
              // text input stays visible and the picker fills leftover height.
              var footer = document.querySelector(_this.container);
              var popup = footer === null || footer === void 0 || (_footer$closest = footer.closest) === null || _footer$closest === void 0 ? void 0 : _footer$closest.call(footer, '.chat-popup');
              var html = SaitoInputSelectionBox(_this);
              if (popup && footer && footer.parentNode === popup) {
                var el = document.createElement('div');
                popup.insertBefore(el, footer);
                el.outerHTML = html;
              } else {
                var chatHost = document.querySelector("".concat(_this.container, " .saito-input"));
                _this.app.browser.addElementToDom(html, chatHost || null);
              }
              _this.attachSelectionBoxTabEvents();
              _this.attachSelectionBoxSearchBridge();
              _this.attachSelectionBoxCloseEvent();

              // close selection box by clicking outside
              document.onclick = function (e) {
                if (!document.querySelector('.saito-input-selection-box').contains(e.target)) {
                  _this.removeSelectionBox();
                }
              };
              _this.addEmojiEvent();
            }
          }
        };
      }

      //
      // On single line inputs, interpret return key as submission
      //
      var msg_input = document.querySelector("".concat(this.container, " .saito-input .text-input"));
      if (msg_input) {
        msg_input.onkeydown = function (e) {
          if ((e.which == 13 || e.keyCode == 13) && !e.shiftKey) {
            // check if saito mention list is open
            // if open avoid triggerting 'enter' btn
            if (document.querySelector("".concat(_this.container, " #saito-mentions-list"))) {
              var status = document.querySelector("".concat(_this.container, " #saito-mentions-list")).getAttribute('status');
              if (status == 'show') {
                return;
              }
            }
            e.preventDefault();
            if (_this.callbackOnReturn) {
              _this.callbackOnReturn(_this.getInput(false));
              msg_input.value = '';
            }
          }
        };
        this.app.browser.addSaitoMentions(document.querySelector("".concat(this.container, " .saito-input .text-input")), document.querySelector("".concat(this.container, " #saito-mentions-list")), 'div');
      }
    }
  }, {
    key: "attachSelectionBoxTabEvents",
    value: function attachSelectionBoxTabEvents() {
      var _this2 = this;
      Array.from(document.querySelectorAll('.saito-input-selection-box .saito-box-tab')).forEach(function (tab) {
        tab.onclick = function (e) {
          e.stopPropagation();
          if (e.currentTarget.id === 'selection-box-close') {
            _this2.removeSelectionBox();
            return;
          }
          Array.from(document.querySelectorAll('.saito-input-selection-box .selection-box-pane.active-tab')).forEach(function (pane) {
            pane.classList.remove('active-tab');
          });
          Array.from(document.querySelectorAll('.saito-input-selection-box .saito-box-tab')).forEach(function (tab2) {
            tab2.classList.remove('active');
          });
          var selected_tab = e.currentTarget.getAttribute('id').replace('tab', 'window');
          e.currentTarget.classList.add('active');
          if (document.getElementById(selected_tab)) {
            document.getElementById(selected_tab).classList.add('active-tab');
          }
          _this2.syncSelectionBoxHeaderMode(selected_tab);
          if (selected_tab === 'emoji-window') {
            _this2.addEmojiEvent();
          } else if (selected_tab === 'gif-window') {
            _this2.addGiphyEvent();
          } else if (selected_tab === 'photo-window') {
            _this2.addPhotoEvent();
          }
        };
      });
    }
  }, {
    key: "attachSelectionBoxCloseEvent",
    value: function attachSelectionBoxCloseEvent() {
      var _this3 = this;
      var closeBtn = document.querySelector('.saito-input-selection-box #selection-box-close');
      if (!closeBtn) {
        return;
      }
      closeBtn.onclick = function (e) {
        e.stopPropagation();
        _this3.removeSelectionBox();
      };
    }
  }, {
    key: "syncSelectionBoxHeaderMode",
    value: function syncSelectionBoxHeaderMode() {
      var selected_tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'emoji-window';
      var searchWrap = document.querySelector('.saito-input-selection-box .selection-box-search-wrap');
      if (searchWrap) {
        searchWrap.classList.toggle('hidden', selected_tab !== 'emoji-window');
      }
      if (selected_tab === 'emoji-window') {
        var shellSearch = document.querySelector('.saito-input-selection-box .selection-box-emoji-search');
        if (shellSearch && !this.app.browser.isMobileBrowser()) {
          setTimeout(function () {
            return shellSearch.focus({
              focusVisible: true
            });
          }, 0);
        }
      }
    }
  }, {
    key: "attachSelectionBoxSearchBridge",
    value: function attachSelectionBoxSearchBridge() {
      var _this4 = this;
      var shellSearch = document.querySelector('.saito-input-selection-box .selection-box-emoji-search');
      if (!shellSearch || shellSearch.dataset.bridgeAttached) {
        return;
      }
      shellSearch.dataset.bridgeAttached = '1';
      shellSearch.addEventListener('input', function () {
        _this4.forwardShellSearchToPicker(shellSearch.value);
      });
      shellSearch.addEventListener('keydown', function (e) {
        var _document$querySelect;
        var pickerSearch = (_document$querySelect = document.querySelector('emoji-picker')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.shadowRoot) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector('input.search');
        if (!pickerSearch) {
          return;
        }
        // Keep picker keyboard navigation working while focus is on the shell field.
        if (['ArrowDown', 'ArrowUp', 'Enter', 'Home', 'End'].includes(e.key)) {
          pickerSearch.dispatchEvent(new KeyboardEvent('keydown', {
            key: e.key,
            code: e.code,
            bubbles: true,
            cancelable: true
          }));
        }
      });
    }
  }, {
    key: "forwardShellSearchToPicker",
    value: function forwardShellSearchToPicker() {
      var _picker$shadowRoot;
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var picker = document.querySelector('emoji-picker');
      var pickerSearch = picker === null || picker === void 0 || (_picker$shadowRoot = picker.shadowRoot) === null || _picker$shadowRoot === void 0 ? void 0 : _picker$shadowRoot.querySelector('input.search');
      if (!pickerSearch) {
        return;
      }
      if (pickerSearch.value !== value) {
        pickerSearch.value = value;
      }
      pickerSearch.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, {
    key: "attachLargeEvents",
    value: function attachLargeEvents() {
      var _this5 = this;
      //Switch between tabs
      this.open_tab = '';
      Array.from(document.querySelectorAll("".concat(this.container, " .saito-box-tab"))).forEach(function (tab) {
        tab.onclick = function (e) {
          e.stopPropagation();
          var selected_tab = e.currentTarget.getAttribute('id').replace('tab', 'window');
          if (selected_tab == _this5.open_tab) {
            _this5.removeSelectionBox();
            return;
          }
          _this5.removeSelectionBox();
          _this5.open_tab = selected_tab;
          _this5.app.browser.addElementToDom(SaitoInputSelectionBox(_this5));

          // close selection box by clicking outside
          document.onclick = function (event) {
            if (!document.querySelector('.saito-input-selection-box').contains(event.target)) {
              _this5.removeSelectionBox();
            }
          };
          setTimeout(function () {
            switch (_this5.open_tab) {
              case 'emoji-window':
                _this5.addEmojiEvent();
                break;
              case 'gif-window':
                _this5.addGiphyEvent();
                break;
              case 'photo-window':
                _this5.addPhotoEvent();
                break;
              default:
            }
          }, 5);
        };
      });
      var msg_input = document.querySelector("".concat(this.container, " .saito-input .text-input"));
      if (msg_input) {
        msg_input.addEventListener('keydown', function (e) {
          if (e.keyCode === 13 && e.ctrlKey) {
            e.preventDefault();
            if (_this5.callbackOnReturn) {
              _this5.callbackOnReturn();
            }
          }
          if ((e.keyCode == 50 || e.charCode == 64) && e.key == '@') {}
        });
        this.app.browser.addSaitoMentions(document.querySelector("".concat(this.container, " .saito-input .text-input")), document.querySelector(this.container + ' #saito-mentions-list'), 'input');
      }
    }
  }, {
    key: "getInput",
    value: function getInput() {
      var _this6 = this;
      var as_html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var inputBox = document.querySelector("".concat(this.container, " .saito-input .text-input"));
      var input = '';

      //
      // Include replies as an auto-mention
      //
      if (this.quote_src) {
        this.mentions.push(this.quote_src);
      }
      if (this.quote) {
        input = "".concat(this.quote);
      }

      //
      // Contenteditable (esp in Firefox) has a tendency to add a <br> tag if you hit the spacebar
      // This should fix some formatting issues in chat/redsquare posts by trimming that extra (final <br> tag)
      //
      var lastTag = inputBox.lastElementChild;
      if (lastTag && lastTag.tagName == 'BR') {
        lastTag.remove();
      }
      if (as_html) {
        input += (inputBox === null || inputBox === void 0 ? void 0 : inputBox.innerHTML) || '';
      } else {
        input += (inputBox === null || inputBox === void 0 ? void 0 : inputBox.innerText) || (inputBox === null || inputBox === void 0 ? void 0 : inputBox.value) || '';
      }

      //
      // Scan input for @ mentions
      //
      this.app.browser.extractMentions(input).forEach(function (mention) {
        if (!_this6.mentions.includes(mention)) {
          _this6.mentions.push(mention);
        }
      });
      return input;
    }
  }, {
    key: "getMentions",
    value: function getMentions() {
      return this.mentions.slice();
    }
  }, {
    key: "setInput",
    value: function setInput(text) {
      var inputBox = document.querySelector("".concat(this.container, " .saito-input .text-input"));
      if (inputBox) {
        inputBox.innerHTML = sanitize(text);
      }
      this.focus();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.clearQuote();
      this.setInput('');
      this.mentions = [];
      this.focus();
    }
  }, {
    key: "clearQuote",
    value: function clearQuote() {
      this.quote = '';
      this.quote_src = '';
      if (document.querySelector('.saito-input-quote')) {
        document.querySelector('.saito-input-quote').remove();
      }
    }
  }, {
    key: "insertQuote",
    value: function insertQuote(quote, src_key) {
      var _this7 = this;
      this.clearQuote();
      this.quote_src = src_key;
      this.quote = sanitize(quote);
      this.app.browser.prependElementToSelector("<div class=\"saito-input-quote\"><i class=\"fas fa-reply\"></i>".concat(this.quote, "<i class=\"fa-solid fa-xmark cancel-quote\"></i></div>"), "".concat(this.container, " .saito-input"));
      this.focus();
      if (document.querySelector('.cancel-quote')) {
        document.querySelector('.cancel-quote').onclick = function (e) {
          _this7.quote = '';
          if (document.querySelector('.saito-input-quote')) {
            document.querySelector('.saito-input-quote').remove();
          }
        };
      }
    }
  }, {
    key: "insertRange",
    value: function insertRange(text) {
      var inputBox = document.querySelector("".concat(this.container, " .saito-input .text-input"));
      if (inputBox) {
        inputBox.innerHTML = sanitize(text);
        var range = document.createRange();
        var sel = document.getSelection();
        range.setStart(inputBox, 2);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
      this.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var inputBox = document.querySelector("".concat(this.container, " .saito-input .text-input"));
      if (inputBox) {
        // even if "forced"
        if (force || !this.isOtherInputActive()) {
          var range = document.createRange();
          var selection = window.getSelection();
          range.setStart(inputBox, inputBox.childNodes.length);
          range.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range);
          setTimeout(function () {
            inputBox.focus();
          }, 0);
          //setTimeout(function(){ inputBox.selectionStart = inputBox.selectionEnd = 10000; }, 0);
        } else {
          this.isOtherInputActive(true);
        }
      }
    }

    /*
    TODO -- SelectionBox should probably be it's own component class with render and attachEvents and remove fucntions
    */
  }, {
    key: "removeSelectionBox",
    value: function removeSelectionBox() {
      if (document.querySelector('emoji-picker')) {
        document.body.append(document.querySelector('emoji-picker'));
      }
      if (document.querySelector('.saito-input-selection-box')) {
        document.querySelector('.saito-input-selection-box').remove();
      }
      document.onclick = null;
      this.open_tab = '';
      this.giphy_rendered = false;
      this.focus();
    }
  }, {
    key: "addPhotoEvent",
    value: function addPhotoEvent() {
      var _this8 = this;
      // open file selector directly in mobile, because we cant drag drop in mobile
      if (document.getElementById(this.photo_handle)) {
        document.getElementById(this.photo_handle).click();
        this.removeSelectionBox();
        return;
      } else {
        //Add photo loading functionality to this selection-box
        this.photo_handle = 'hidden_file_element_photo-window';
        this.app.browser.addDragAndDropFileUploadToElement("photo-window", /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(filesrc) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  document.querySelector('.photo-window').innerHTML = '';
                  _this8.loader.render();
                  _context.n = 1;
                  return _this8.app.browser.resizeImg(filesrc);
                case 1:
                  filesrc = _context.v;
                  // (img, size, {dimensions})
                  _this8.loader.remove();
                  if (_this8.callbackOnUpload) {
                    _this8.callbackOnUpload(filesrc);
                  } else if (_this8.callbackOnReturn) {
                    _this8.callbackOnReturn(filesrc);
                  }
                  _this8.removeSelectionBox();
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "addEmojiEvent",
    value: function addEmojiEvent() {
      var _this9 = this;
      // Update globally scoped output field
      window['emoji-output'] = "".concat(this.container, " .saito-input .text-input");
      if (!document.querySelector('emoji-picker')) {
        this.app.browser.addElementToDom('<emoji-picker></emoji-picker>');
        //Make sure we only add event listener once (because we keep the emoji-picker in DOM)
        document.querySelector('emoji-picker').addEventListener('emoji-click', function (event) {
          var emoji = event.detail;
          var input = document.querySelector(window['emoji-output']);
          if (!input || !(emoji !== null && emoji !== void 0 && emoji.unicode)) {
            // we have one picker for multiple possible input windows
            return;
          }
          _this9.insertEmojiUnicode(input, emoji.unicode);
          if (_this9.display == 'large') {
            //this.removeSelectionBox();
          } else {
            _this9.removeSelectionBox();
          }
        });
      }
      var picker = document.querySelector('emoji-picker');
      if (picker) {
        //Insert emoji-window back into window
        var container = document.getElementById('emoji-window');
        if (container) {
          container.append(picker);
        }
        var shellSearch = document.querySelector('.saito-input-selection-box .selection-box-emoji-search');
        if (shellSearch) {
          // Chat selection box owns the visible search field; hide the picker's.
          picker.setAttribute('data-saito-shell-search', '');
          this.attachSelectionBoxSearchBridge();
          this.forwardShellSearchToPicker(shellSearch.value || '');
          if (!this.app.browser.isMobileBrowser()) {
            shellSearch.focus({
              focusVisible: true
            });
          }
        } else {
          var _picker$shadowRoot2;
          picker.removeAttribute('data-saito-shell-search');
          var search_bar = (_picker$shadowRoot2 = picker.shadowRoot) === null || _picker$shadowRoot2 === void 0 ? void 0 : _picker$shadowRoot2.querySelector('input.search');
          if (search_bar && !this.app.browser.isMobileBrowser()) {
            search_bar.focus({
              focusVisible: true
            });
          }
        }
      }
    }

    /*
     * Insert emoji as inline text. Contenteditable must not use innerHTML +=,
     * which lets the browser keep/create <br>/block structure (visible newlines).
     */
  }, {
    key: "insertEmojiUnicode",
    value: function insertEmojiUnicode(input, unicode) {
      var _input$tagName, _input$getAttribute;
      var tag = (_input$tagName = input.tagName) === null || _input$tagName === void 0 ? void 0 : _input$tagName.toLowerCase();
      if (tag === 'textarea' || tag === 'input') {
        var _input$selectionStart, _input$selectionEnd;
        var start = (_input$selectionStart = input.selectionStart) !== null && _input$selectionStart !== void 0 ? _input$selectionStart : input.value.length;
        var end = (_input$selectionEnd = input.selectionEnd) !== null && _input$selectionEnd !== void 0 ? _input$selectionEnd : start;
        if (typeof input.setRangeText === 'function') {
          input.setRangeText(unicode, start, end, 'end');
        } else {
          input.value = input.value.slice(0, start) + unicode + input.value.slice(end);
          var caret = start + unicode.length;
          input.selectionStart = input.selectionEnd = caret;
        }
        input.dispatchEvent(new Event('input', {
          bubbles: true
        }));
        return;
      }

      // Chat uses contenteditable .text-input
      if (input.isContentEditable || ((_input$getAttribute = input.getAttribute) === null || _input$getAttribute === void 0 ? void 0 : _input$getAttribute.call(input, 'contenteditable')) === 'true') {
        // Empty editors often contain a caret placeholder <br>; keep it and we get a newline.
        if (!(input.textContent || '').length) {
          input.replaceChildren();
        }
        var sel = window.getSelection();
        var range = null;
        if (sel && sel.rangeCount > 0) {
          var candidate = sel.getRangeAt(0);
          if (input === candidate.commonAncestorContainer || input.contains(candidate.commonAncestorContainer)) {
            range = candidate;
          }
        }
        var textNode = document.createTextNode(unicode);
        if (range) {
          range.deleteContents();
          range.insertNode(textNode);
        } else {
          input.appendChild(textNode);
        }
        var after = document.createRange();
        after.setStartAfter(textNode);
        after.collapse(true);
        if (sel) {
          sel.removeAllRanges();
          sel.addRange(after);
        }
        input.dispatchEvent(new Event('input', {
          bubbles: true
        }));
        return;
      }

      // Last resort: textContent append (still no HTML / <br>)
      input.textContent = "".concat(input.textContent || '').concat(unicode);
    }
  }, {
    key: "addGiphyEvent",
    value: function () {
      var _addGiphyEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this0 = this;
        var gif_mod, gif_function;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.giphy_rendered) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              gif_mod = this.app.modules.respondTo('giphy');
              gif_function = (gif_mod === null || gif_mod === void 0 ? void 0 : gif_mod.length) > 0 ? gif_mod[0].respondTo('giphy') : null;
              if (gif_function) {
                gif_function.renderInto('#gif-window', function (gif_source) {
                  if (_this0.callbackOnUpload) {
                    _this0.callbackOnUpload(gif_source);
                  } else if (_this0.callbackOnReturn) {
                    _this0.callbackOnReturn(gif_source);
                  }
                  _this0.removeSelectionBox();
                });
                this.giphy_rendered = true;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function addGiphyEvent() {
        return _addGiphyEvent.apply(this, arguments);
      }
      return addGiphyEvent;
    }() //
    // Maybe needs improvement, but simple test to not rip away
    // focus from a ChatPopup if rendering a new Chatpopup
    //
  }, {
    key: "isOtherInputActive",
    value: function isOtherInputActive() {
      var debug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (document.querySelector('.saito-input-selection-box')) {
        if (debug) console.log('.saito-input-selection-box');
        return 1;
      }
      var ep = document.querySelector('emoji-picker');
      if (ep && window.getComputedStyle(ep).display !== 'none') {
        if (debug) console.log('emoji-picker: ' + window.getComputedStyle(ep).display);
        return 1;
      }
      var ae = document.activeElement;
      var this_input = document.querySelector(this.container + ' .saito-input');
      if (!ae) {
        return 0;
      }
      var parent = ae.parentNode;
      while (parent) {
        if (parent === this_input) {
          return 0;
        }
        parent = parent.parentNode;
      }
      if (ae.tagName.toLowerCase() == 'input' || ae.tagName.toLowerCase() == 'textarea') {
        return 1;
      }
      if (ae.classList.contains('text-input')) {
        return 1;
      }
      return 0;
    }
  }]);
}();
module.exports = SaitoInput;